export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'

export const SUBSCRIBER_FILTER_CHANGED = 'SUBSCRIBER_FILTER_CHANGED'
export const SUBSCRIBER_ORDER_CHANGED = 'SUBSCRIBER_ORDER_CHANGED'

export const ADD_FAVORITE = 'ADD_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'

export const ADD_FILTER = 'ADD_FILTER'
export const DELETE_FILTER = 'DELETE_FILTER'

export const SET_CONFIG = 'SET_CONFIG'
export const SET_MAINTENANCE_INFO = 'SET_MAINTENANCE_INFO'
export const DISMISS_MAINTENANCE_INFO = 'DISMISS_MAINTENANCE_INFO'


// WEBPACK FOOTER //
// ./constants/actions.js